import React from "react";


const Filter = ({column, table}) => {
//  function Filter({ column, table }) {


    const firstValue = table
      .getPreFilteredRowModel()
      .flatRows[0]?.getValue(column.id)
  
    const columnFilterValue = column.getFilterValue()
  
    return typeof firstValue === "number" ? (
      <div className="input-group" onClick={e => e.stopPropagation()}>
        <input
          type="number"
          value={columnFilterValue?.[0] ?? ""}
          onChange={e => column.setFilterValue(old => [e.target.value, old?.[1]])}
          placeholder={`Min`}
          className="form-control form-control-sm max-num-filter"
        />
        <span className="input-group-addon">-</span>
        <input
          type="number"
          value={columnFilterValue?.[1] ?? ""}
          onChange={e => column.setFilterValue(old => [old?.[0], e.target.value])}
          placeholder={`Max`}
          className="form-control form-control-sm  max-num-filter"
        />
      </div>
    ) : (

      <input
        className="form-control form-control-sm  max-string-filter"
        onChange={e => column.setFilterValue(e.target.value)}
        onClick={e => e.stopPropagation()}
        placeholder={`Search...`}
        type="text"
        value={columnFilterValue ?? ""}
      />
    )
  }
    export default Filter;